<section class="container">
<h2 class="main-title" [innerHTML]="data?.title"></h2>
<p class="section-subtitle" *ngIf="data?.subtitle" [innerHTML]="data.subtitle"></p>
<div class="card-list d-flex flex-wrap gap-4">
  <div
    class="bordered-card"
    *ngFor="let card of data?.cards"
    style="flex: 1 1 300px; max-width: 100%;"
  >
    <div class="icon-container">
      <i [class]="card.imgsrc"></i>
    </div>

    <div class="card-content">
      <h3 class="card-title" [innerHTML]="card.cardTitle"></h3>
      <p class="card-description" [innerHTML]="card.content"></p>
    </div>
  </div>
</div>

<!-- Only show button if "button" exists in JSON -->
<div class="button-wrapper" *ngIf="data?.button">
  <app-app-button
    [buttonText]="data.button.buttonText"
    [link]="data.button.link"
    [disabled]="data.button.disabled">
  </app-app-button>
</div>
</section>